import { useState } from "react";
import  "./FlavourLevel.css";


const FlavourLevel = ({data,handleChange, count})=>{
  const [val, setVal] = useState(data.flavourlevel===0?0:data.flavourlevel);


  function onChangeValue(event) {
   setVal(event.target.value);
   handleChange(event);
 }
    return (
  <div class="flavourlevelCard" name="flavourlevel"  onChange={onChangeValue}>
    <div class="flavourlevel-rating-container">

      <div class="flavourlevel-rating">
        <form class="flavourlevel-rating-form-1">

          <label for={`FAL1F-${count}`}>
            <input type="radio"  name="flavourlevel" class="flavourlevel1" id={`FAL1F-${count}`}  value="6"  checked={'' + val === "6"} />
                <div className="aromacircle1"></div>
                <p>6</p>
           </label>

          <label for={`FAL2F-${count}`}>
              <input type="radio" name="flavourlevel" class="flavourlevel2" id={`FAL2F-${count}`} value="6.25" checked={'' + val === "6.25"} />
                <div className="aromacircle2"></div>
               <p className="invisible">.5</p>
           </label>

          <label for={`FAL3F-${count}`}>
              <input type="radio" name="flavourlevel" class="flavourlevel3" id={`FAL3F-${count}`} value="6.5" checked={'' + val === "6.5"} />
                <div className="aromacircle3"></div>
                <p className="invisible">.5</p>
            </label>

          <label for={`FAL4F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel4" id={`FAL4F-${count}`} value="6.75" checked={'' + val === "6.75"} />
               <div className="aromacircle4"></div>
               <p className="invisible">.5</p>

            </label>

          <label for={`FAL5F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel5" id={`FAL5F-${count}`} value="7" checked={'' + val === "7"} />
                <div className="aromacircle5"></div>
                <p>7</p>
             </label>
             {/* Didn't change it after this */}
             <label for={`FAL6F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel6" id={`FAL6F-${count}`} value="7.25" checked={'' + val === "7.25"} />
                <div className="aromacircle6"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL7F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel7" id={`FAL7F-${count}`} value="7.5" checked={'' + val === "7.5"} />
                <div className="aromacircle7"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL8F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel8" id={`FAL8F-${count}`} value="7.75" checked={'' + val === "7.75"} />
                <div className="aromacircle8"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL9F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel9" id={`FAL9F-${count}`} value="8" checked={'' + val === "8"} />
                <div className="aromacircle9"></div>
                <p>8</p>

             </label>

             <label for={`FAL10F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel10" id={`FAL10F-${count}`} value="8.25" checked={'' + val === "8.25"} />
                <div className="aromacircle10"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL11F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel11" id={`FAL11F-${count}`} value="8.5" checked={'' + val === "8.5"} />
                <div className="aromacircle11"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL12F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel12" id={`FAL12F-${count}`} value="8.75" checked={'' + val === "8.75"} />
                <div className="aromacircle12"></div>
                <p className="invisible">.5</p>
             </label>


             <label for={`FAL13F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel13" id={`FAL13F-${count}`} value="9" checked={'' + val === "9"} />
                <div className="aromacircle13"></div>
                <p>9</p>
             </label>

             <label for={`FAL14F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel14" id={`FAL14F-${count}`} value="9.25" checked={'' + val === "9.25"} />
                <div className="aromacircle14"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL15F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel15" id={`FAL15F-${count}`} value="9.5" checked={'' + val === "9.5"} />
                <div className="aromacircle15"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL16F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel16" id={`FAL16F-${count}`} value="9.75" checked={'' + val === "9.75"} />
                <div className="aromacircle16"></div>
                <p className="invisible">.5</p>
             </label>

             <label for={`FAL17F-${count}`}>
             <input type="radio" name="flavourlevel" class="flavourlevel17" id={`FAL17F-${count}`} value="10" checked={'' + val === "10"} />
                <div className="aromacircle17"></div>
                <p>10</p>
             </label>



        </form>
      </div>
    </div>
  </div>


    );
}

export default FlavourLevel;